import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';
export { Navigation, Thumbs, Pagination, FreeMode, Autoplay } from 'swiper/modules';
export { Swiper, SwiperSlide } from 'swiper/react';
export type { SwiperOptions } from 'swiper/types';
